import React, { useState, useEffect } from 'react';
import { Search, FileCheck, Shield } from 'lucide-react';

export const ProcessSlider = () => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      icon: Search,
      title: 'Step 1: Comprehensive Search',
      description: 'We conduct a thorough trademark search across federal and state databases to ensure your mark is available. Our detailed analysis identifies potential conflicts and provides you with a comprehensive report, giving you confidence before filing.'
    },
    {
      icon: FileCheck,
      title: 'Step 2: Professional Filing',
      description: 'Our experienced trademark attorneys prepare and file your application with the USPTO. We ensure all documentation is accurate and complete, maximizing your chances of approval. Your application is typically filed within 24-48 hours of receiving your information.'
    },
    {
      icon: Shield,
      title: 'Step 3: Monitoring & Protection',
      description: 'After filing, we monitor your application status and handle all USPTO correspondence. Once approved, we provide ongoing trademark monitoring to protect your brand from potential infringements, ensuring your intellectual property remains secure.'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % steps.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="max-w-5xl mx-auto">
      {/* Desktop View */}
      <div className="hidden md:grid md:grid-cols-3 gap-8">
        {steps.map((step, index) => {
          const Icon = step.icon;
          return (
            <div
              key={index}
              className={`bg-white rounded-xl p-8 shadow-lg transition-all duration-500 ${
                activeStep === index ? 'ring-4 ring-red-600 scale-105' : 'opacity-70 scale-95'
              }`}
            >
              <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                <Icon className="w-8 h-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{step.title}</h3>
              <p className="text-gray-600 text-center">{step.description}</p>
            </div>
          );
        })}
      </div>

      {/* Mobile Slider */}
      <div className="md:hidden">
        <div className="bg-white rounded-xl p-8 shadow-lg">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className={`transition-all duration-500 ${
                  activeStep === index ? 'block' : 'hidden'
                }`}
              >
                <div className="bg-red-100 w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto">
                  <Icon className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{step.title}</h3>
                <p className="text-gray-600 text-center">{step.description}</p>
              </div>
            );
          })}
        </div>
        <div className="flex justify-center space-x-2 mt-6">
          {steps.map((_, index) => (
            <button
              key={index}
              onClick={() => setActiveStep(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                activeStep === index ? 'bg-red-600 w-8' : 'bg-gray-300'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Step Indicators for Desktop */}
      <div className="hidden md:flex justify-center space-x-2 mt-8">
        {steps.map((_, index) => (
          <button
            key={index}
            onClick={() => setActiveStep(index)}
            className={`w-3 h-3 rounded-full transition-all ${
              activeStep === index ? 'bg-red-600 w-8' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
};